import * as Sentry from '@sentry/react';

// No connection yet returns 404; the connect page treats that as "not connected".
export function ignoreCommandAlkonConnection404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorResponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/command_alkon\/connection$/;
  const isFetchingCommandAlkonConnection = regexp.test(requestUrl);

  return is404ErrorResponse && isGETRequest && isFetchingCommandAlkonConnection;
}
